var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-settings"},[_c('Currencies'),_c('CategoriesTable'),_c('company-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }